// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__2qLMA","openModalButton":"style_openModalButton__1bERl"};